'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

exports.default = function () {
    var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    theme = Object.assign({}, baseTheme(theme), theme);

    if (this.props.primary) {
        theme = Object.assign({}, theme, (0, _primary2.default)(theme), theme.primary);
    } else if (this.props.secondary || this.props.warning) {
        theme = Object.assign({}, theme, (0, _secondary2.default)(theme), theme.secondary);
    } else if (this.props.error) {
        theme = Object.assign({}, theme, (0, _error2.default)(theme), theme.error);
    } else if (this.props.primaryInversion) {
        theme = Object.assign({}, theme, (0, _primaryInversion2.default)(theme), theme.primaryInversion);
    } else if (this.props.flat) {
        theme = Object.assign({}, theme, (0, _flat2.default)(theme), theme.flat);
    } else if (this.props.flatPrimary) {
        theme = Object.assign({}, theme, (0, _flatPrimary2.default)(theme), theme.flatPrimary);
    } else if (this.props.tag) {
        theme = Object.assign({}, theme, (0, _tag2.default)(theme), theme.tag);
    } else if (this.props.tagPrimary) {
        theme = Object.assign({}, theme, (0, _tagPrimary2.default)(theme), theme.tagPrimary);
    }

    if (this.props.rounded) {
        theme.borderRadius = '100px';
    }

    if (this.props.square) {
        theme.paddingRight = theme.gutter + 'px';
        theme.paddingLeft = theme.gutter + 'px';
    }

    if (this.props.circle) {
        theme.paddingRight = theme.gutter + 'px';
        theme.paddingLeft = theme.gutter + 'px';
        theme.borderRadius = '50%';
    }

    if (this.props.multiline) {
        theme.whiteSpace = 'normal';
    }

    var minHeight = (0, _pixelToNumber2.default)(theme.fontSize) * theme.lineHeight + (0, _pixelToNumber2.default)(theme.paddingTop) + (0, _pixelToNumber2.default)(theme.paddingBottom);

    var styleList = _aphroditeJss.StyleSheet.create({
        root: {
            display: 'inline-block',
            minWidth: theme.minWidth,
            minHeight: minHeight + 'px',
            width: theme.width,
            // default global background
            background: '#FFF',
            borderRadius: theme.borderRadius
        },
        animation: {
            position: 'absolute',
            width: '27px',
            height: '27px',
            top: 0,
            left: '30px',
            backgroundColor: theme.animationBackgroundColor,
            borderRadius: '50%',

            '&-enter': {
                transition: 'opacity 2s ' + theme.animationTransitionFunction + ', transform 1s ' + theme.animationTransitionFunction,
                opacity: 0.75,
                transform: 'scale(0)'
            },

            '&-enter-active': {
                opacity: 0,
                transform: 'scale(10)'
            }
        },
        animationContainer: {
            display: theme.animationDisplay,
            width: '100%',
            height: '100%',
            position: 'absolute',
            top: 0,
            left: 0,
            overflow: 'hidden',
            borderRadius: theme.borderRadius,
            /* this fixes the overflow:hidden in Chrome for border-radius */
            '-webkit-mask-image': 'url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAIAAACQd1PeAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAA5JREFUeNpiYGBgAAgwAAAEAAGbA+oJAAAAAElFTkSuQmCC)'
        },
        field: {
            position: 'relative',
            fontSize: theme.fontSize,
            lineHeight: theme.lineHeight,
            fontFamily: theme.fontFamily,
            fontWeight: theme.fontWeight,
            paddingTop: theme.paddingTop,
            paddingRight: theme.paddingRight,
            paddingBottom: theme.paddingBottom,
            paddingLeft: theme.paddingLeft,
            borderRadius: theme.borderRadius,
            transitionProperty: 'background, border, box-shadow, color',
            transitionDuration: theme.transitionDuration,
            transitionTimingFunction: theme.transitionFunction,
            width: '100%',
            color: theme.color,
            background: theme.background,
            boxShadow: theme.boxShadow,
            whiteSpace: theme.whiteSpace,
            borderStyle: theme.borderStyle,
            borderWidth: theme.borderWidth,
            borderColor: theme.borderColor,

            '& a': {
                color: theme.color
            },

            '&:focus': {
                outline: '0 none',
                color: theme.focusColor,
                borderColor: theme.focusBorderColor,
                backgroundColor: theme.focusBackground,
                boxShadow: theme.focusBoxShadow
            },
            '&:hover': {
                color: theme.hoverColor,
                borderColor: theme.hoverBorderColor,
                backgroundColor: theme.hoverBackground,
                boxShadow: theme.hoverBoxShadow,
                cursor: this.props.disabled ? 'not-allowed' : 'pointer'
            },
            '&:active': {
                color: theme.activeColor,
                borderColor: theme.activeBorderColor,
                backgroundColor: theme.activeBackground,
                boxShadow: theme.activeBoxShadow
            },
            '&[disabled]': {
                color: theme.disabledColor,
                borderColor: theme.disabledBorderColor,
                backgroundColor: theme.disabledBackground,
                boxShadow: theme.disabledBoxShadow
            }
        }
    });

    return {
        root: (0, _aphroditeJss.css)(styleList.root),
        animation: (0, _aphroditeJss.css)(styleList.animation),
        animationContainer: (0, _aphroditeJss.css)(styleList.animationContainer),
        field: (0, _aphroditeJss.css)(styleList.field)
    };
};

var _aphroditeJss = require('aphrodite-jss');

var _primary = require('./primary');

var _primary2 = _interopRequireDefault(_primary);

var _secondary = require('./secondary');

var _secondary2 = _interopRequireDefault(_secondary);

var _error = require('./error');

var _error2 = _interopRequireDefault(_error);

var _primaryInversion = require('./primaryInversion');

var _primaryInversion2 = _interopRequireDefault(_primaryInversion);

var _flat = require('./flat');

var _flat2 = _interopRequireDefault(_flat);

var _flatPrimary = require('./flatPrimary');

var _flatPrimary2 = _interopRequireDefault(_flatPrimary);

var _tag = require('./tag');

var _tag2 = _interopRequireDefault(_tag);

var _tagPrimary = require('./tagPrimary');

var _tagPrimary2 = _interopRequireDefault(_tagPrimary);

var _pixelToNumber = require('../../style/pixelToNumber');

var _pixelToNumber2 = _interopRequireDefault(_pixelToNumber);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var baseTheme = function baseTheme(theme) {
    return {
        animationDisplay: 'block',
        animationBackgroundColor: theme.elLight,
        animationTransitionFunction: theme.transitionFunction,
        minWidth: theme.gutter * 5 + 'px',
        width: 'auto',
        borderRadius: '2px',
        fontSize: theme.tsNormal,
        fontWeight: theme.twSemi,
        lineHeight: 1.5,
        fontFamily: theme.fontFamily,
        color: theme.tInactive,
        textAlign: 'left',
        borderColor: theme.elPrimary,
        background: theme.elPrimary,
        boxShadow: '0 2px 4px 0 ' + theme.elShadowMain,
        paddingTop: theme.gutter + 'px',
        paddingBottom: theme.gutter + 'px',
        paddingRight: theme.gutter * 2 + 'px',
        paddingLeft: theme.gutter * 2 + 'px',
        transitionDuration: theme.transitionDuration,
        transitionFunction: theme.transitionFunction,
        whiteSpace: 'nowrap',
        borderStyle: 'none',
        borderWidth: 0,

        focusColor: theme.tInactive,
        focusBorderColor: theme.elPrimary,
        focusBackground: theme.elPrimary,
        focusBoxShadow: '0 2px 4px 0 ' + theme.elShadowMain,

        hoverColor: theme.tFilled,
        hoverBorderColor: theme.elLightest,
        hoverBackground: theme.elLightest,
        hoverBoxShadow: '0 2px 4px 0 ' + theme.elShadowMain,

        activeColor: theme.tActive,
        activeBorderColor: theme.elPrimary,
        activeBackground: theme.elPrimary,
        activeBoxShadow: '0 8px 8px 0 ' + theme.elShadow + ', 0 0 8px 0 ' + theme.elShadow,

        disabledColor: theme.tDisabled,
        disabledBorderColor: theme.elLightest,
        disabledBackground: theme.elLightest,
        disabledBoxShadow: 'none'
    };
};